<template>
  <div class="applyInvoice">
    <van-nav-bar
      title="申请开票"
      left-text=""
      left-arrow
      fixed
      class="main-nav"
      @click-left="onClickLeft"
    />
    <div
      class="applyInvoice_content"
      v-loading="loading"
      element-loading-text="数据加载中..."
    >
      <p class="applyInvoice_content_title">发票详情</p>
      <div class="applyInvoice_content_money">
        <p>
          开票金额：<span>¥{{ moneyTol }}</span>
        </p>
      </div>
      <van-form @submit="onSubmit">
        <div class="applyInvoice_content_main">
          <van-field
            name="radio"
            label="抬头类型："
            required
            class="applyInvoice_content_main_radio"
          >
            <template #input>
              <van-radio-group
                v-model="radio"
                direction="horizontal"
                checked-color="#00AADF"
              >
                <van-radio name="1">企业单位</van-radio>
                <van-radio name="2">个人/非企业单位</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <div class="enterprise" v-if="radio == 1">
            <van-field
              v-model="enterprise.head"
              name="title"
              label="发票抬头："
              @input="onInput"
              required
              placeholder="填写需要开具发票的企业名称"
              :rules="[
                {
                  required: true,
                  message: '发票抬头不能为空',
                  trigger: 'onBlur',
                },
                {
                  validator: this.titleTest,
                  message: '请输入汉字',
                  trigger: 'onBlur',
                },
              ]"
            />
            <van-field
              v-model="enterprise.duty"
              name="taxNo"
              label="公司税号："
              @input="onInput1"
              required
              placeholder="纳税人识别号"
              :rules="[
                {
                  required: true,
                  message: '公司税号不能为空',
                  trigger: 'onBlur',
                },
                {
                  validator: this.dutyTest,
                  message: '请输入18位的大写字母或数字',
                  trigger: 'onBlur',
                },
              ]"
            />
            <van-field
              v-model="enterprise.content"
              name="content"
              label="发票内容："
              placeholder="迪夫"
            />
            <van-field
              v-model="enterprise.bank"
              name="bank"
              label="开户行："
              placeholder="非必填"
              @input="onInput"
              :rules="[
                {
                  validator: this.titleTest,
                  message: '请输入汉字',
                  trigger: 'onBlur',
                },
              ]"
            />
            <van-field
              v-model="enterprise.account"
              name="bankAccount"
              label="开户帐号："
              placeholder="非必填"
              @input="onInput1"
              :rules="[
                {
                  validator: this.accountTest,
                  message: '请输入数字',
                  trigger: 'onBlur',
                },
              ]"
            />
            <van-field
              v-model="enterprise.ticketParty"
              name="invoiceName"
              label="开票方："
              placeholder="迪夫"
            />
          </div>
          <div class="people" v-if="radio == 2">
            <van-field
              v-model="people.content"
              name="content"
              label="发票内容："
              placeholder="迪夫"
            />
            <van-field
              v-model="people.phone"
              name="phone"
              label="电话："
              placeholder="电话"
              @input="onInput2"
              :rules="[
                {
                  validator: this.phoneTest,
                  message: '请输入正确的手机号',
                  trigger: 'onBlur',
                },
              ]"
            />
            <van-field
              v-model="people.ticketParty"
              name="invoiceName"
              label="开票方："
              placeholder="迪夫"
            />
          </div>
        </div>
        <p class="applyInvoice_content_title">接收方式</p>
        <div class="applyInvoice_content_money applyInvoice_content_email">
          <van-field
            v-model="email"
            name="email"
            label="电子邮箱："
            placeholder="电子邮箱"
            required
            :rules="[
              {
                required: true,
                message: '电子邮箱不能为空',
                trigger: 'onBlur',
              },
              {
                validator: this.emailTest,
                message: '邮箱格式错误',
                trigger: 'onBlur',
              },
            ]"
          />
        </div>
        <van-button
          class="applyInvoice_content_fix"
          round
          block
          type="info"
          native-type="submit"
          >提交</van-button
        >
      </van-form>
    </div>
    <dialog-common
      :infoShow="show"
      :infoTitle="infoTitle"
      :infoMsg="infoMsg"
      :sureMsg="sureMsg"
      @goback="close"
      @next="next"
    ></dialog-common>
  </div>
</template>
<script>
import dialogCommon from "@/components/dialogCommon";
import { _applyInvoice } from "../../api/setting";
export default {
  name: "applyInvoice",
  data() {
    return {
      moneyTol: 0, //开票金额
      radio: "1", //抬头类型标识
      loading: false, //loading标识
      enterprise: {
        //企业
        head: "", //发票抬头
        duty: "", //公司税号
        content: "", //发票内容
        bank: "", //开户银行
        account: "", //银行卡号
        ticketParty: "", //开票方
      },
      people: {
        //个人
        content: "", //发票内容
        phone: "", //电话号码
        ticketParty: "", //开票方
      },
      email: "", //邮箱
      show: false, //弹窗标识
      infoTitle: "电子发票提交成功", //弹窗title
      infoMsg: "本次发票申请已提交成功，可在开票历史中查看进度", //弹窗内容
      sureMsg: "查看开票进度", //按钮内容
      idList: [], //开发票订单id数组
    };
  },
  components: {
    dialogCommon,
  },
  created() {
    this.moneyTol = this.$route.query.moneyTol;
    this.idList = JSON.parse(localStorage.getItem("ordersId"));
  },
  mounted() {},
  methods: {
    // 返回
    onClickLeft() {
      this.$router.go(-1);
    },
    //提交发票
    onSubmit(values) {
      let data = values;
      data.type = data.radio == 1 ? 1 : 2;
      data.amount = this.moneyTol;
      data.orders = this.idList;
      this.applyInvoice(data);
    },
    //公司抬头最多可输入30字符
    onInput() {
      this.enterprise.head = this.enterprise.head.substring(0, 30);
    },
    //银行卡号最多可输入18位
    onInput1() {
      this.enterprise.duty = this.enterprise.duty.substring(0, 18);
    },
    //手机号最多可输入18位
    onInput2() {
      this.people.phone = this.people.phone.substring(0, 11);
    },
    //只能输入汉字
    titleTest(value) {
      const title = /^[\u4e00-\u9fa5]+$/;
      if (title.test(value) || !value) {
        return true;
      } else {
        return false;
      }
    },
    //只能输入大写字母和数字
    dutyTest(value) {
      var regex = /^[0-9A-Z]+$/;
      if (regex.test(value) || !value) {
        return true;
      } else {
        return false;
      }
    },
    //只能输入数字
    accountTest(value) {
      var regex = /^[0-9]*$/;
      if (regex.test(value) || !value) {
        return true;
      } else {
        return false;
      }
    },
    //邮箱验证
    emailTest(value) {
      var regex =
        /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      if (regex.test(value) || !value) {
        return true;
      } else {
        return false;
      }
    },
    //手机号验证
    phoneTest(value) {
      var regex =
        /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      if (regex.test(value) || !value) {
        return true;
      } else {
        return false;
      }
    },
    //关闭弹窗
    close() {
      this.show = false;
    },
    //弹窗确定
    next() {
      // this.onClickLeft();
      // 查看开票进度 进入开票历史页
      // this.$router.push({ path: "/invoice" });
      this.$router.go(-1);
    },
    //申请发票
    applyInvoice(data) {
      this.loading = true;
      _applyInvoice(data)
        .then((res) => {
          if (res && res.code == 200) {
            this.loading = false;
            this.show = true;
          } else {
            Toast(res.message);
            this.loading = false;
          }
        })
        .catch((err) => {
          throw err;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.applyInvoice {
  height: 100%;
  background: #f5f7fa;
  .applyInvoice_content {
    padding-top: 48px;
    position: relative;
    height: 100%;
    .applyInvoice_content_title {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #949c9d;
      margin: 8px 0 4px 20px;
    }
    .applyInvoice_content_money {
      width: 335px;
      height: 54px;
      background: #ffffff;
      border-radius: 8px;
      margin-left: 20px;
      margin-bottom: 8px;
      p {
        margin-left: 10px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #2e4344;
        line-height: 54px;
        span {
          font-size: 18px;
          font-family: DINAlternate-Bold, DINAlternate;
          font-weight: bold;
          color: #fa7d00;
        }
      }
    }
    .applyInvoice_content_main {
      width: 335px;
      padding: 20px 10px;
      background: #ffffff;
      border-radius: 8px;
      margin-left: 20px;
      .applyInvoice_content_main_radio {
        ::v-deep .van-cell__title {
          margin-left: 6px;
        }
      }
      .enterprise,
      .people {
        ::v-deep .van-cell {
          margin-top: 20px;
        }
      }
    }
    .applyInvoice_content_email {
      display: flex;
      align-items: center;
      padding-left: 10px;
    }
    .applyInvoice_content_fix {
      position: fixed;
      bottom: 38px;
      width: 335px;
      height: 40px;
      background: linear-gradient(180deg, #17e1eb 0%, #24bffb 100%);
      border-radius: 20px;
      left: 20px;
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #ffffff;
      text-align: center;
      line-height: 40px;
      border: none;
    }
  }
}
.van-cell {
  padding: 0;
}
::v-deep .van-field__label {
  width: 74px;
  margin-right: 0;
}
::v-deep .van-radio__label {
  font-size: 13px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #2e4344;
}
::v-deep .van-cell--required:before {
  left: 0;
}
::v-deep .van-cell:after {
  border: none;
}
::v-deep .van-cell__title {
  margin-left: 6px;
}
</style>
